var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    filter: "url(#filter0_d_462_2436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval 10 Copy",
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7949 37.0049C32.488 37.0049 39.5351 30.0538 39.5351 21.479C39.5351 12.9043 32.488 5.95312 23.7949 5.95312C15.1018 5.95312 8.05469 12.9043 8.05469 21.479C8.05469 30.0538 15.1018 37.0049 23.7949 37.0049Z",
    stroke: "#12110B",
    strokeWidth: 0.782013
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M28.9406 18.6064C28.8675 18.525 28.7498 18.5045 28.6532 18.5547C28.5931 18.5859 28.4802 18.6269 28.3461 18.6673C28.5152 18.4391 28.6512 18.1836 28.7113 17.954C28.7373 17.855 28.6993 17.7506 28.6166 17.6916C28.534 17.6331 28.4239 17.6331 28.3413 17.6916C28.211 17.7838 27.5824 18.0608 27.1849 18.1505C26.2867 17.3523 25.2413 17.2694 24.1547 17.913C23.2713 18.4362 23.0791 19.5002 23.1166 20.1487C21.0946 19.9512 19.8379 18.8677 19.1304 17.971C19.0809 17.9081 19.0011 17.875 18.9261 17.8799C18.8473 17.8857 18.7762 17.9301 18.7358 17.9988C18.4013 18.5718 18.3086 19.2052 18.4686 19.8308C18.5561 20.1721 18.7089 20.473 18.8862 20.7168C18.8012 20.6743 18.719 20.6212 18.6416 20.5578C18.5705 20.4983 18.471 20.4871 18.3869 20.5266C18.3033 20.5671 18.2499 20.6529 18.2499 20.747C18.2499 21.8212 18.9122 22.538 19.5307 22.9125C19.4308 22.9003 19.3265 22.8778 19.2212 22.8452C19.1309 22.8174 19.0328 22.8452 18.9704 22.9173C18.9079 22.989 18.893 23.0914 18.9319 23.1787C19.2794 23.9584 19.9378 24.4948 20.7525 24.6893C20.0412 25.113 19.0891 25.3208 18.2172 25.2189C18.1043 25.2028 17.9966 25.2754 17.9611 25.3856C17.9255 25.4958 17.9721 25.6167 18.0716 25.6733C19.3943 26.4267 20.59 26.6958 21.6233 26.6958C23.1271 26.6958 24.2878 26.1263 24.9943 25.6499C26.899 24.3675 28.0861 22.065 27.9207 20.0049C28.2259 19.7762 28.6825 19.3539 28.9656 18.8999C29.0242 18.8083 29.0136 18.6873 28.9406 18.6064Z",
    fill: "#12110B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_462_2436",
    x: 0.625945,
    y: 0.870421,
    width: 46.338,
    height: 45.9122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.34604
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51906
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_2436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_2436",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.7b161455fea895f2dd0733c4d1da882a.svg";
export { ForwardRef as ReactComponent };